// import Vue from 'vue';
import * as types from './../type';
// import store from './../index'
const state = {
  orderStatus:'', //订单状态 订货
  paymentState:'', //付款状态 订货
  returnTrial:'', //订单状态 退货
  exchangeTrial:'', //订单状态 换货

  tableTabs:[], //全局tab

};
const actions = {

};
const mutations = {
  [types.GET_ORDERGOODS](state,res) { //订单状态 订货
    if(res=='1'||res=='9'){
      state.orderStatus = res;
    }else if(res=='0'){
      state.paymentState = res;
    }else{
      state.orderStatus = res;
      state.paymentState = res;
    }
  },
  [types.GET_RETURNBILL](state,res) { //订单状态 退货
    state.returnTrial = res;
  },
  [types.GET_SWAPORDER](state,res) { //订单状态 换货
    state.exchangeTrial = res;
  },
};
const getters = {

};
export default {
  state,
  actions,
  mutations,
  getters,
}



// WEBPACK FOOTER //
// ./src/vuex/home/home.js